import { Component, inject, signal, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

import { InvestigatorTransactionSupportingSectionComponent } from '../investigator-transaction-supporting-section/investigator-transaction-supporting-section.component';

@Component({
  imports: [InvestigatorTransactionSupportingSectionComponent],
  templateUrl: './investigator-transactions-save-modal.component.html',
})
export class InvestigatorTransactionsSaveModalComponent {
  ref = inject(CustomOverlayRef);

  uploadingFiles = signal(false);

  noteFormControl = new FormControl('', [Validators.required]);
  @ViewChild('supportingSection')
  supportingSection?: InvestigatorTransactionSupportingSectionComponent;

  async save() {
    if (this.noteFormControl.invalid) {
      return;
    }

    this.uploadingFiles.set(true);

    const { documents, note } = (await this.supportingSection?.saveSupportingSection()) || {};

    this.uploadingFiles.set(false);

    this.ref.close({
      documents,
      note,
    });
  }
}
